module.exports = __webpack_public_path__ + "static/CardOfDarkness0-ba9e6b68a80771eeeab39f46b48a6a8e.png";